import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-loading-overlay',
  template: `
    <div class="loading-modal fade show" *ngIf="show" role="dialog" aria-modal="true" [attr.aria-label]="message">
      <div class="loading-modal-backdrop"></div>
      <div class="loading-modal-content">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">{{ message }}</span>
        </div>
        <strong>{{ message }}</strong>
      </div>
    </div>
  `,
  styles: [`
    .loading-modal {
      align-items: center;
      display: grid;
      inset: 0;
      justify-items: center;
      opacity: 0;
      position: fixed;
      transition: opacity 0.15s linear;
      z-index: 1055;
    }

    .loading-modal.show {
      opacity: 1;
    }

    .loading-modal-backdrop {
      background: rgba(3, 16, 13, 0.82);
      inset: 0;
      position: absolute;
    }

    .loading-modal-content {
      align-items: center;
      background: rgba(2, 20, 16, 0.94);
      border: 1px solid rgba(250, 232, 60, 0.26);
      border-radius: 8px;
      box-shadow: 0 22px 80px rgba(0, 0, 0, 0.46);
      color: #fef08a;
      display: grid;
      gap: 1rem;
      justify-items: center;
      min-width: min(86vw, 320px);
      padding: 2rem;
      position: relative;
      text-align: center;
    }

    .spinner-border {
      animation: spinner-border 0.75s linear infinite;
      border: 0.25em solid currentColor;
      border-radius: 50%;
      border-right-color: transparent;
      color: #fef08a;
      display: inline-block;
      height: 3rem;
      vertical-align: -0.125em;
      width: 3rem;
    }

    .visually-hidden {
      clip: rect(0, 0, 0, 0) !important;
      border: 0 !important;
      height: 1px !important;
      margin: -1px !important;
      overflow: hidden !important;
      padding: 0 !important;
      position: absolute !important;
      white-space: nowrap !important;
      width: 1px !important;
    }

    @keyframes spinner-border {
      to {
        transform: rotate(360deg);
      }
    }
  `]
})
export class LoadingOverlayComponent {
  @Input() show = false;
  @Input() message = 'Caricamento...';
}
